import React from 'react';
import FormInput from 'components/FormInput';

const LocationStep = () => (
  <>
    <div className='same-line'>
      <FormInput
        label='Straatnaam *'
        id='streetname'
        placeholder='Vlinderlaan'
        customClass='long-input'
      />
      <FormInput
        label='Nummer *'
        id='housenumber'
        placeholder='11'
        customClass='short-input'
      />
    </div>

    <div className='same-line'>
      <FormInput
        label='Postcode *'
        id='zipcode'
        placeholder='3833HH'
        customClass='short-input'
      />
      <FormInput
        label='Woonplaats *'
        id='city'
        placeholder='Zeewolde'
        customClass='long-input'
      />
    </div>
  </>
);

export default LocationStep;
